import { useEffect, useState } from 'react';

interface ConfirmDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText: string;
  isLoading: boolean;
  confirmButtonText?: string;
  loadingText?: string;
  confirmButtonClassName?: string;
}

export default function ConfirmDeleteDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  isLoading,
  confirmButtonText = 'Delete',
  loadingText = 'Deleting...',
  confirmButtonClassName = 'bg-red-600 text-white hover:bg-red-700',
}: ConfirmDeleteDialogProps) {
  const [typed, setTyped] = useState('');

  useEffect(() => {
    if (!open) setTyped('');
  }, [open]);

  if (!open) return null;

  const matches = typed === confirmText;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h2 className="text-xl font-bold mb-4">{title}</h2>
        <p className="text-gray-600 mb-4">{message}</p>
        <p className="text-sm text-gray-700 mb-2">
          To confirm, type <span className="font-mono font-semibold">{confirmText}</span> below:
        </p>
        <input
          type="text"
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          disabled={isLoading}
          autoFocus
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-6"
          placeholder={confirmText}
        />
        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading || !matches}
            className={`px-4 py-2 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed ${confirmButtonClassName}`}
          >
            {isLoading ? loadingText : confirmButtonText}
          </button>
        </div>
      </div>
    </div>
  );
}
